
export default {
  _default_lower: [
    [
      { 'symbol': '1' },
      { 'symbol': '2' },
      { 'symbol': '3' },
      { 'symbol': '4' },
      { 'symbol': '5' },
      { 'symbol': '6' },
      { 'symbol': '7' },
      { 'symbol': '8' },
      { 'symbol': '9' },
      { 'symbol': '0' },
      { 'symbol': '-' },
      { 'symbol': '=' },
      { 'label': '\u21E6', 'symbol': 'backspace', 'keysize': 2, 'color': 'danger' },
    ],
    [
      { 'symbol': 'q', 'label': 'q' },
      {
        'symbol': 'w',
        'label': 'w'
      },
      {
        'symbol': 'e',
        'label': 'e'
      },
      {
        'symbol': 'r',
        'label': 'r'
      },
      {
        'symbol': 't',
        'label': 't'
      },
      {
        'symbol': 'y',
        'label': 'y'
      },
      {
        'symbol': 'u',
        'label': 'u'
      },
      {
        'symbol': 'i',
        'label': 'i'
      },
      {
        'symbol': 'o',
        'label': 'o'
      },
      {
        'symbol': 'p',
        'label': 'p'
      },
      {
        'symbol': '['
      },
      {
        'symbol': ']'
      },
      {
        'symbol': '\\'
      },
    ],
    [{
      'symbol': 'a',
      'label': 'a'
    },
    {
      'symbol': 's',
      'label': 's'
    },
    {
      'symbol': 'd',
      'label': 'd'
    },
    {
      'symbol': 'f',
      'label': 'f'
    },
    {
      'symbol': 'g',
      'label': 'g'
    },
    {
      'symbol': 'h',
      'label': 'h'
    },
    {
      'symbol': 'j',
      'label': 'j'
    },
    {
      'symbol': 'k',
      'label': 'k'
    },
    {
      'symbol': 'l',
      'label': 'l'
    },
    {
      'symbol': ';'
    },
    {
      'symbol': '\''
    },
    {blank: true}
      // {
      //   'label': '\u23CE',
      //   'symbol': 'enter',
      //   'keysize': 2,
      //   'color': 'success'
      // }
    ],
    [{
      'label': '\u21E7',
      'symbol': 'set_upper',
      'keysize': 2
    },
    {
      'symbol': 'z',
      'label': 'z'
    },
    {
      'symbol': 'x',
      'label': 'x'
    },
    {
      'symbol': 'c',
      'label': 'c'
    },
    {
      'symbol': 'v',
      'label': 'v'
    },
    {
      'symbol': 'b',
      'label': 'b'
    },
    {
      'symbol': 'n',
      'label': 'n'
    },
    {
      'symbol': 'm',
      'label': 'm'
    },
    {
      'symbol': ',',
    },
    {
      'symbol': '.',
    },
    {
      'symbol': '/',
    },
    {
      'label': '\u21E7',
      'symbol': 'set_upper',
      'keysize': 2
    },
    ],
    [
      { blank: true, keysize: 2 },
      {
        'label': '\u035F',
        'symbol': ' ',
        'keysize': 10
      },
      { 'label': '⇲', 'symbol': 'close_keyboard', 'keysize': 2, 'color': 'tertiary' },
    ]
  ],
  _default_upper: [
    [
    {
      'symbol': '!'
    },
    {
      'symbol': '@'
    },
    {
      'symbol': '#'
    },
    {
      'symbol': '$'
    },
    {
      'symbol': '%'
    },
    {
      'symbol': '^'
    },
    {
      'symbol': '&'
    },
    {
      'symbol': '*'
    },
    {
      'symbol': '('
    },
    {
      'symbol': ')'
    },
    {
      'symbol': '_'
    },
    {
      'symbol': '+'
    },
    {
      'label': '\u21E6',
      'symbol': 'backspace',
      'keysize': 2,
      'color': 'danger'
    },
    
    ],
    [{
      'symbol': 'Q',
      'label': 'Q'
    },
    {
      'symbol': 'W',
      'label': 'W'
    },
    {
      'symbol': 'E',
      'label': 'E'
    },
    {
      'symbol': 'R',
      'label': 'R'
    },
    {
      'symbol': 'T',
      'label': 'T'
    },
    {
      'symbol': 'Y',
      'label': 'Y'
    },
    {
      'symbol': 'U',
      'label': 'U'
    },
    {
      'symbol': 'I',
      'label': 'I'
    },
    {
      'symbol': 'O',
      'label': 'O'
    },
    {
      'symbol': 'P',
      'label': 'P'
    },
    {
      'symbol': '{'
    },
    {
      'symbol': '}'
    },
    {
      'symbol': '|'
    },
    ],
    [{
      'symbol': 'A',
      'label': 'A'
    },
    {
      'symbol': 'S',
      'label': 'S'
    },
    {
      'symbol': 'D',
      'label': 'D'
    },
    {
      'symbol': 'F',
      'label': 'F'
    },
    {
      'symbol': 'G',
      'label': 'G'
    },
    {
      'symbol': 'H',
      'label': 'H'
    },
    {
      'symbol': 'J',
      'label': 'J'
    },
    {
      'symbol': 'K',
      'label': 'K'
    },
    {
      'symbol': 'L',
      'label': 'L'
    },
    {
      'symbol': ':'
    },
    {
      'symbol': '"'
    },
    {blank: true}
    
    ],
    [{
      'label': '\u21E7',
      'symbol': 'set_lower',
      'color': 'dark',
      'keysize': 2
    },
    {
      'symbol': 'Z',
      'label': 'Z'
    },
    {
      'symbol': 'X',
      'label': 'X'
    },
    {
      'symbol': 'C',
      'label': 'C'
    },
    {
      'symbol': 'V',
      'label': 'V'
    },
    {
      'symbol': 'B',
      'label': 'B'
    },
    {
      'symbol': 'N',
      'label': 'N'
    },
    {
      'symbol': 'M',
      'label': 'M'
    },
    {
      'symbol': '<',
    },
    {
      'symbol': '>',
    },
    {
      'symbol': '?',
    },
    {
      'label': '\u21E7',
      'symbol': 'set_lower',
      'color': 'dark',
      'keysize': 2
    },
    ],
    [
      { blank: true, keysize: 2 },
      {
        'label': '\u035F',
        'symbol': ' ',
        'keysize': 10
      },
      { 'label': '⇲', 'symbol': 'close_keyboard', 'keysize': 2, 'color': 'tertiary' },
    ]
  ],
  keypad: [
    [
      {
        'symbol': '1'
      },
      {
        'symbol': '2'
      },
      {
        'symbol': '3'
      }
    ],
    [
      {
        'symbol': '4'
      },
      {
        'symbol': '5'
      },
      {
        'symbol': '6'
      },
    ],
    [
      {
        'symbol': '7'
      },
      {
        'symbol': '8'
      },
      {
        'symbol': '9'
      },
    ],
    [
      {
        'symbol': '0'
      }
    ],
    [{ blank: true }],
    [
      {
        'label': '\u21E6',
        'symbol': 'backspace',
        'keysize': 1,
        'color': 'danger'
      },
      {
        'label': '\u21E7',
        'symbol': 'prev',
        'keysize': 1,
        'color': 'tertiary'
      },
      {
        'label': '\u21E9',
        'symbol': 'next',
        'keysize': 1,
        'color': 'tertiary'
      }
    ]
  ],
  number: [
    [
      {
        'symbol': '1'
      },
      {
        'symbol': '2'
      },
      {
        'symbol': '3'
      },

    ],
    [
      {
        'symbol': '4'
      },
      {
        'symbol': '5'
      },
      {
        'symbol': '6'
      },
    ],
    [
      {
        'symbol': '7'
      },
      {
        'symbol': '8'
      },
      {
        'symbol': '9'
      },
    ],
    [
      { blank: true },
      {
        'symbol': '0'
      },
      {
        'label': '\u21E6',
        'symbol': 'backspace',
        'keysize': 1,
        'color': 'danger'
      },
    ]
  ]
};

